import { useContext } from 'react';

import { MainContext } from '@ezbobdev/ui-framework';

export const useEventEmitter = () => {
  const { actions } = useContext(MainContext);

  const emitEvent = (type, payload) => {
    actions.events.emit(type, { ...payload });
  };

  return { emitEvent };
};
